import { graphql } from '../../../graphql/generated';

export const MARK_ORDER_LABEL_PRINTED_MUTATION = graphql(`
  mutation MarkOrderLabelPrinted($orderLabelId: ID!) {
    markOrderLabelPrinted(orderLabelId: $orderLabelId) {
      id
      printedAt
    }
  }
`);
